import { useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';

export const useHerdsmanMessageForm = (herdsman, onSubmitSendMessage, onCloseModal, triggerSubmit, setTriggerSubmit) => {
    const buttonSubmitRef = useRef(null);

    const { register, handleSubmit, errors, setValue } = useForm({
        mode: "all",
        reValidateMode: "onBlur",
    });

    useEffect(() => {
        if (herdsman) {
            setValue("herdsmanId", herdsman.id);
        }
    }, [herdsman, setValue]);

    const onSubmit = (data) => {
        if (!data) return;

        if (data.Image && data.Image.length > 0) {
            data.Image = data.Image[0];
        } else {
            data.Image = null;
        }

        onSubmitSendMessage({ ...data, herdsmanId: herdsman?.id });
        onCloseModal();
    };

    useEffect(() => {
        if (!triggerSubmit) return;
        buttonSubmitRef.current.click();
        setTriggerSubmit(false);
    }, [triggerSubmit, setTriggerSubmit]);

    return {
        register, handleSubmit, errors,
        buttonSubmitRef,
        onSubmit
    };
};
